import * as moment from 'moment';
// http://useroffline.blogspot.com/2009/06/making-google-calendar-link.html
var getDemoCopyLink = function (event, t, title) {
    var event_name = t(title) || '';
    if (typeof event_name !== 'undefined') {
        event_name = event_name.replace(/&/g, '%26');
    }
    var description = event.summary || '';
    var location = event.location || '';
    var cloneStart = event.startDate;
    var cloneEnd = event.endDate ? event.endDate : cloneStart;
    var formater = 'YYYYMMDDTHHmmssZ'; // 20090621T063000Z
    var from_date = moment(cloneStart).format(formater);
    var to_date = moment(cloneEnd).format(formater);
    var link = "https://calendar.google.com/calendar/render?action=TEMPLATE&text=".concat(event_name, "&dates=").concat(from_date, "/").concat(to_date, "&details=").concat(description, "&location=").concat(location);
    return link;
};
export default getDemoCopyLink;
//# sourceMappingURL=getDemoCopyLink.js.map